import type { Episode } from './types'

type Props = {
  episode: Episode
  selected: boolean
  disabled: boolean
  onAdd: () => void
  onRemove: () => void
}

const DATE_FMT = new Intl.DateTimeFormat(undefined, {
  year: 'numeric',
  month: 'short',
  day: 'numeric',
})

function excerpt(text: string, max: number): string {
  if (text.length <= max) return text
  return text.slice(0, max - 1).trimEnd() + '…'
}

export default function EpisodeRow({
  episode,
  selected,
  disabled,
  onAdd,
  onRemove,
}: Props) {
  const dateLabel = episode.pubDateMs > 0 ? DATE_FMT.format(new Date(episode.pubDateMs)) : ''
  const minutes = Math.round(episode.audioLengthSec / 60)

  let buttonLabel: string
  let onClick: () => void
  let buttonDisabled = false
  if (selected) {
    buttonLabel = 'Added ✓'
    onClick = onRemove
  } else if (disabled) {
    buttonLabel = 'Tray full'
    onClick = () => {}
    buttonDisabled = true
  } else {
    buttonLabel = '+ Add'
    onClick = onAdd
  }

  return (
    <div className={`episode-row${selected ? ' episode-row--selected' : ''}`}>
      {episode.thumbnail && (
        <img
          src={episode.thumbnail}
          alt=""
          className="episode-row__thumb"
          loading="lazy"
        />
      )}
      <div className="episode-row__body">
        <p className="episode-row__meta">
          {dateLabel}
          {dateLabel && minutes > 0 && ' · '}
          {minutes > 0 && `${minutes} min`}
        </p>
        <h4 className="episode-row__title">{episode.title}</h4>
        {episode.description && (
          <p className="episode-row__description">{excerpt(episode.description, 140)}</p>
        )}
      </div>
      <div className="episode-row__action">
        <button
          type="button"
          className={`btn${selected ? '' : ' btn-primary'}`}
          onClick={onClick}
          disabled={buttonDisabled}
        >
          {buttonLabel}
        </button>
      </div>
    </div>
  )
}
